import React from 'react';
import {BsTwitterX, BsInstagram, BsLinkedin, BsFacebook, BsThreads, BsGithub} from 'react-icons/bs'

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
      <a href="https://x.com/oboh_banny18" target='_blank'><BsTwitterX /></a> 
      </div>
      {/* <div>
       <a href="https://instagram.com/bjmblack?igshid=NGVhN2U2NjQ0Yg==" target='_blank'><BsInstagram /></a> 
      </div> */}
      <div>
        {/* <a href="https://www.facebook.com/benjamin.oboh.334" target='_blank'><BsFacebook /></a> */}
      </div>
      <div>
       <a href="https://www.linkedin.com/in/oboh-barnabas-a36a84247/" target='_blank'><BsLinkedin /></a> 
      </div>
      {/* <div>
       <a href="https://www.threads.net/@bjmblack" target='_blank'><BsThreads /></a> 
      </div> */}
      <div>
       <a href="https://github.com/barneybo18" target='_blank'><BsGithub /></a> 
      </div>
      
    </div>
  )
}

export default SocialMedia